import moment from 'moment'

export const formatDate = (date) => {
    if (!date) { return '' }
    return moment(date).format("DD/MM/YYYY")
}

export const addDays = (date, days) => {
    if (!date) { return date }
    return moment(date).add(days, 'days');
}

export const formatDateTime = (date) => {
    if (!date) { return '' }
    return moment(date).format("DD/MM/YYYY HH:mm")
}

export const formatTime = (date) => {
    if (!date) { return '' }
    return moment(date).format("HH:mm")
}

export const diffInDays = (dateStart, dateEnd) => {
    return moment(dateEnd).diff(moment(dateStart), 'days')
}

export const diffInHoursMinutes = (startDate, endDate) => {
    // Calculate the difference in minutes
    const start = moment(startDate);
    const end = moment(endDate);

    const duration = moment.duration(end.diff(start));

    // Extract hours and minutes
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    // Format the difference as '0:00' (hours:minutes)
    return `${hours}:${minutes.toString().padStart(2, '0')}`;
}

export const minutesToHoursMinutes = (totalMinutes) => {
    // Calculate hours and remaining minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format as 'hours:minutes'
    return `${hours}:${minutes.toString().padStart(2, '0')}`;
}

export const chatTimeCount = (data) => {
    const agora = moment();
    const dataMensagem = moment(data);
    const diferenca = moment.duration(agora.diff(dataMensagem));
    
    if (diferenca.asMinutes() < 1) {
        return 'Menos de 1 minuto atrás';
    } else if (diferenca.asMinutes() < 60) {
        const minutos = Math.floor(diferenca.asMinutes());
        return `${minutos} minuto${minutos > 1 ? 's' : ''} atrás`;
    } else if (diferenca.asHours() < 24) {
        const horas = Math.floor(diferenca.asHours());
        return `${horas} hora${horas > 1 ? 's' : ''} atrás`;
    } else if (diferenca.asDays() < 7) {
        const dias = Math.floor(diferenca.asDays());
        return `${dias} dia${dias > 1 ? 's' : ''} atrás`;
    } else if (diferenca.asWeeks() < 4) {
        const semanas = Math.floor(diferenca.asWeeks());
        return `${semanas} semana${semanas > 1 ? 's' : ''} atrás`;
    } else if (diferenca.asMonths() < 12) {
        return `Mais de 1 mês atrás`;
    } else {
        return `Mais de um ano atrás`;
    }
}

export const formatDateTimeApi = (date) => {
    if (!date) { return null }
    return moment(date).format("YYYY-MM-DD HH:mm")
}

const addMomentFilters = (app) => {
    app.config.globalProperties.$moment = {
        formatDate: formatDate,
        formatDateTime: formatDateTime,
        formatTime: formatTime,
        chatTimeCount: chatTimeCount,
        addDays: addDays,
        diffInDays: diffInDays,
        diffInHoursMinutes: diffInHoursMinutes,
        minutesToHoursMinutes: minutesToHoursMinutes,
    }
}

export default addMomentFilters
